import React, { useState, useEffect } from 'react';
import c from 'classnames';
import Modal from 'react-modal';
import { useTranslation } from 'react-i18next';
import IconButton from '@wix/da-ds/pkg/Buttons/IconButton';
import BurgerIcon from '@wix/da-ds/pkg/Icons/Burger';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import NetworkBar from '../../../NetworkBar';
import s from './Burger.scss';
var Burger = function (_a) {
    var isBurgerMenuOpen = _a.isBurgerMenuOpen, toggleBurgerMenu = _a.toggleBurgerMenu, iconClassName = _a.iconClassName, _b = _a.showNetworkBar, showNetworkBar = _b === void 0 ? true : _b;
    var t = useTranslation().t;
    var _c = useState(isBurgerMenuOpen), showModal = _c[0], setShowModal = _c[1];
    var _d = useState(false), isClosing = _d[0], setIsClosing = _d[1];
    // because of the hover-hack, we cannot rely on react-modal to handle the body locking for us
    useEffect(function () {
        if (isBurgerMenuOpen) {
            document.body.classList.add(s['body-lock']);
            return function () { return document.body.classList.remove(s['body-lock']); };
        }
    }, [isBurgerMenuOpen]);
    return (React.createElement(React.Fragment, null,
        React.createElement(IconButton, { size: "medium", "aria-expanded": isBurgerMenuOpen, "aria-label": t('siteHeader.burger.a11y'), "aria-controls": "burger-menu-networkbar", icon: BurgerIcon, className: iconClassName, onClick: function () {
                /* the Modal will render before this, isBurgerMenuOpen only controls opacity and starts the animation */
                toggleBurgerMenu(!isBurgerMenuOpen);
            }, 
            /* add the Modal to the DOM so we can show animation */
            onMouseEnter: function () { return setShowModal(true); }, 
            /* if the menu is not open remove the Modal */
            onMouseLeave: function () { return !isBurgerMenuOpen && setShowModal(false); }, biData: {
                evid: BiEventType.NETWORK_BAR_MENU_ICON,
                is_expanding: isBurgerMenuOpen || isClosing ? 0 : 1,
            } }),
        showNetworkBar && (React.createElement(Modal, { isOpen: showModal, shouldCloseOnOverlayClick: true, shouldCloseOnEsc: true, className: c(s['modal-root'], isBurgerMenuOpen && s['modal-root-open']), overlayClassName: c(s['overlay'], isBurgerMenuOpen && s['overlay-open']), bodyOpenClassName: null, onRequestClose: function () {
                setIsClosing(true);
                /* wait for animation to finish to remove the Modal */
                setTimeout(function () {
                    setShowModal(false);
                    setIsClosing(false);
                }, 300);
                toggleBurgerMenu(false);
            } },
            React.createElement(NetworkBar, { id: "burger-menu-networkbar", isVisible: isBurgerMenuOpen })))));
};
Burger.displayName = 'Burger';
export default Burger;
//# sourceMappingURL=Burger.js.map